import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Button } from '@sparknz/spark-pattern-library';

const StyledButton = styled(Button)`
  ${({ theme: { media, spacing } }) => css`
    padding-top: ${spacing.s1};

    ${media.up('slim')} {
      padding-top: ${spacing.s1_5};
    }
  `}
`;

interface ShowAllFiltersProps {
  onShowAll: () => void;
}

function ShowAllFiltersButton({ onShowAll }: ShowAllFiltersProps) {
  return (
    <Box flexWrap="wrap" ml="s2" flexDirection="column" justifyContent="center">
      <StyledButton variant="textbutton" onClick={onShowAll}>
        Show all filters
      </StyledButton>
    </Box>
  );
}

export default ShowAllFiltersButton;
